<div class="mainContainer">
  <div class="logoContainer">
    <div
      class="ImageContainer"
      [ngClass]="{
        'default-logo': this.ImageURL == null || this.ImageURL.trim() == ''
      }"
    >
      <img
        *ngIf="!(this.ImageURL == null || this.ImageURL.trim() == '')"
        [src]="ImageURL"
        alt="Logo"
        class="inner-image"
      />
    </div>
    <div class="divider"></div>
    <div class="study-name-area">
      <div class="study-header-name" (click)="studyDropdown()">
        <div class="study-block">
          {{studyName}}
        </div>
        <div class="study-open-icon">
        </div>
      </div>
      
      <div class="StudyListArea" *ngIf="showStudyDropdown" id="study-dropdown">
        <div class="studyDropdown" *ngFor="let study of studyListData">
          <div class="studyDropdown_Container" (click)="navigateStudy(study)">
            <div class="studyDropdown_Container_Name" [class.selected_Text]="study === studyName">{{ study }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
